<template>
  <v-app class="pldc" style="height: 100%; max-width: 450px;"
   :class="{on_desktop: $vuetify.breakpoint.smAndUp}"
  >
    <v-system-bar absolute app window color="#004056" 
      style="max-width: 450px; height: 64px"
      class="d-flex justify-center pt-1 pb-2"
    >
      <img src="@/assets/referra-pro-app-logo-305x104.png" height="52px">
    </v-system-bar>

    <v-main style="height: calc(100% - 32px);">
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'WizardLayout',
}
</script>

<style>
  html, body {
    height: 100%;
  }

  .v-application--wrap {
    min-height: 100vh !important;
    min-height: -webkit-fill-available !important;
  }
</style>